import React, { useEffect, useState } from "react";
import Footer12 from "../shared/Footer12";
import Navbar12 from "../shared/Navbar12";
import Sidebar12 from "../shared/Sidebar12";
import { useNavigate } from "react-router-dom";
import config from "../../config";

function Dashboard12() {
  const navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      const token = sessionStorage.getItem("tokenclassxii");
      try {
        const response = await fetch(
          `${config.API_BASE_URL}/PrincipalDashboardCount_CL12`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch dashboard data");
        }

        const data = await response.json();
        setDashboardData(data?.data?.dashboardCount_list);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  return (
    <div className="container-scroller">
      <Navbar12 />

      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}

      <div className="container-fluid page-body-wrapper">
        <Sidebar12 />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 mb-3">
                <div className="row">
                  <div className="col-12 col-xl-12 mb-4 mb-xl-0">
                    <h3
                      className="font-weight-bold"
                      style={{ textTransform: "uppercase" }}
                    >
                      Welcome Principal
                    </h3>
                    <h6
                      className="font-weight-normal mb-2"
                      style={{ textTransform: "uppercase" }}
                    >
                      School Code: {sessionStorage.getItem("schoolCode")}
                    </h6>
                    <h6 className="font-weight-normal mb-0">
                      {sessionStorage.getItem("schoolname")}
                    </h6>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              {/* TOTAL COUNT */}
              <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                <a
                  href="#"
                  className="card card-success"
                  style={{ textDecoration: "none" }}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/class-xii-total-registration");
                  }}
                >
                  <div className="card-body">
                    <div className="row">
                      <div
                        className="col-md-6"
                        style={{ borderRight: "1px solid #FFFFFF" }}
                      >
                        <h3 className="mb-2">
                          Total <br /> Count
                        </h3>
                        <p className="fs-30 mb-2 mt-4">
                          {dashboardData?.totaL_REGISTERED_STUDENT ?? "0"}
                        </p>
                      </div>
                      <div className="col-md-6" style={{ fontWeight: 600 }}>
                        <p className="fs-10 mb-2 mt-1">
                          Private: {dashboardData?.checklisT_PRIVATE ?? "0"}
                        </p>
                        <p className="fs-10 mb-2 mt-1">
                          Regular: {dashboardData?.checklisT_REGULAR ?? "0"}
                        </p>
                        <p className="fs-10 mb-2 mt-1">
                          Ex-regular:{" "}
                          {dashboardData?.checklisT_EX_REGULAR ?? "0"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <span className="small-box-footer">Print Checklist</span>
                  </div>
                </a>
              </div>

              {/* QUOTA - SCIENCE */}
              <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                <div
                  className="card card-light-danger"
                  style={{ textDecoration: "none" }}
                >
                  <div className="card-body">
                    <div className="row">
                      <div
                        className="col-md-6"
                        style={{ borderRight: "1px solid #FFFFFF" }}
                      >
                        <h3 className="mb-2">
                          Student Count <br /> for Science
                        </h3>
                        <p className="fs-30 mb-2 mt-4">
                          {dashboardData?.quotA_SCIENCE ?? "0"}
                        </p>
                      </div>
                      <div className="col-md-6" style={{ fontWeight: 600 }}>
                        <p className="fs-10 mb-2 mt-1">
                          Regular:{" "}
                          {dashboardData?.quotA_SCIENCE_REGULAR_FILLUP ?? "0"}/
                          {dashboardData?.quotA_SCIENCE_REGULAR ?? "0"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* QUOTA - COMMERCE */}
              <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                <div
                  className="card data-icon-card-secondary"
                  style={{ textDecoration: "none" }}
                >
                  <div className="card-body">
                    <div className="row">
                      <div
                        className="col-md-6"
                        style={{ borderRight: "1px solid #FFFFFF" }}
                      >
                        <h3 className="mb-2">
                          Student Count <br /> for Commerce
                        </h3>
                        <p className="fs-30 mb-2 mt-4">
                          {dashboardData?.quotA_COMMERCE ?? "0"}
                        </p>
                      </div>
                      <div className="col-md-6" style={{ fontWeight: 600 }}>
                        <p className="fs-10 mb-2 mt-1">
                          Private:{" "}
                          {dashboardData?.quotA_COMMERCE_PRIVATE_FILLUP ?? "0"}/
                          {dashboardData?.quotA_COMMERCE_PRIVATE ?? "0"}
                        </p>
                        <p className="fs-10 mb-2 mt-1">
                          Regular:{" "}
                          {dashboardData?.quotA_COMMERCE_REGULAR_FILLUP ?? "0"}/
                          {dashboardData?.quotA_COMMERCE_REGULAR ?? "0"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* QUOTA - ARTS */}
              <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                <div
                  className="card card-light-blue"
                  style={{ textDecoration: "none" }}
                >
                  <div className="card-body">
                    <div className="row">
                      <div
                        className="col-md-6"
                        style={{ borderRight: "1px solid #FFFFFF" }}
                      >
                        <h3 className="mb-2">
                          Student Count <br /> for Arts
                        </h3>
                        <p className="fs-30 mb-2 mt-4">
                          {dashboardData?.quotA_ARTS ?? "0"}
                        </p>
                      </div>
                      <div className="col-md-6" style={{ fontWeight: 600 }}>
                        <p className="fs-10 mb-2 mt-1">
                          Private:{" "}
                          {dashboardData?.quotA_ARTS_PRIVATE_FILLUP ?? "0"}/
                          {dashboardData?.quotA_ARTS_PRIVATE ?? "0"}
                        </p>
                        <p className="fs-10 mb-2 mt-1">
                          Regular:{" "}
                          {dashboardData?.quotA_ARTS_REGULAR_FILLUP ?? "0"}/
                          {dashboardData?.quotA_ARTS_REGULAR ?? "0"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* CHECKLIST GENERATED */}
              <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/class-xii-checklist-generated");
                  }}
                  className="card card-dark-blue"
                  style={{ textDecoration: "none" }}
                >
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-8">
                        <h3 className="mb-2">
                          Checklist <br /> Generated
                        </h3>
                        <p className="fs-30 mb-2 mt-4">
                          {dashboardData?.checklisT_GENERATED ?? "0"}
                        </p>
                      </div>
                      <div className="col-md-4" style={{ textAlign: "center" }}>
                        <i
                          className="fa fa-list icon-large"
                          style={{ fontSize: "40px" }}
                        ></i>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              {/* PENDING CHALLAN */}
              <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/class-xii-generate-challan");
                  }}
                  className="card card-orange"
                  style={{ textDecoration: "none" }}
                >
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-8">
                        <h3 className="mb-2">
                          Pending for <br /> Challan Generation
                        </h3>
                        <p className="fs-30 mb-2 mt-4">
                          {dashboardData?.pendinG_FOR_CHALLAN_GENERATION ?? "0"}
                        </p>
                      </div>
                      <div className="col-md-4" style={{ textAlign: "center" }}>
                        <i
                          className="fa fa-clock-o icon-large"
                          style={{ fontSize: "40px" }}
                        ></i>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              {/* CHALLAN STATUS */}
              <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/class-xii-challan-status");
                  }}
                  className="card card-dark-danger"
                  style={{ textDecoration: "none" }}
                >
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-8">
                        <h3 className="mb-2">
                          Challan <br /> Status
                        </h3>
                        <p className="fs-30 mb-2 mt-4">
                          {dashboardData?.generateD_CHALLAN_STATUS ?? "0"}
                        </p>
                      </div>
                      <div className="col-md-4" style={{ textAlign: "center" }}>
                        <i
                          className="fa fa-clipboard icon-large"
                          style={{ fontSize: "40px" }}
                        ></i>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              {/* LIST OF EXAMINEE */}
              <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/class-xii-consolidated-checklist");
                  }}
                  className="card card-dark-danger"
                  style={{ textDecoration: "none" }}
                >
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-8">
                        <h3 className="mb-2">
                          List of <br /> Examinees
                        </h3>
                        <p className="fs-30 mb-2 mt-4">
                          {dashboardData?.lisT_OF_EXAMINEE ?? "0"}
                        </p>
                      </div>
                      <div className="col-md-4" style={{ textAlign: "center" }}>
                        <i
                          className="fa fa-download icon-large"
                          style={{ fontSize: "40px" }}
                        ></i>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              {/* CHALLAN LIMIT */}
              <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                <div
                  className="card card-light-danger"
                  style={{ textDecoration: "none" }}
                >
                  <div className="card-body">
                    <div className="row">
                      <div
                        className="col-md-6"
                        style={{ borderRight: "1px solid #FFFFFF" }}
                      >
                        <h3 className="mb-2">
                          Challan <br /> Limit
                        </h3>
                        <p className="fs-30 mb-2 mt-4">
                          {dashboardData?.challaN_LIMIT || "0"}
                        </p>
                      </div>
                      <div className="col-md-6" style={{ fontWeight: 600 }}>
                        <h3 className="mb-2">
                          Challan <br /> Left
                        </h3>
                        <p className="fs-30 mb-2 mt-4">
                          {dashboardData?.challaN_LEFT || "0"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer12 />
        </div>
      </div>
    </div>
  );
}

export default Dashboard12;
